import React, { useEffect, useState } from "react";
import { formatValueUnit, selectedOptic, userData } from "../js/utils";
import { post } from "../js/post";
import ButtonIconH from "./ButtonIconH";
import LoadingScreen from "./LoadingScreen";
import "../css/SalesManagement.css";
import "../css/ShoppingCart.css";
import { prepareOrder } from "../support-extra/js/prepareOrder";

export default function ShoppingCart({
  patientId,
  createPopupQuestion,
  removePopupQuestion,
  onClose,
  onClickMenuOption,
}) {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loadingData, setLoadingData] = useState(true);

  async function getShoppingCart() {
    const response = await post("/support-extra/cesta/ObtenerCesta.php", {
      token: userData.token,
      idPaciente: patientId,
      idOptica: selectedOptic.id,
    });
    setData(response);
    setLoadingData(false);
  }

  function getLabel(category, pos) {
    const labels = {
      gafas: ["Montura", "Lente derecha", "Lente izquierda"],
      LC: ["LC derecha", "LC izquierda", "Líquido"],
      audifonos: ["Audífono derecho", "Audífono izquierdo", "Cargador"],
    };

    return labels[category]?.[pos] || "";
  }

  function showData(e, pos) {
    const categoryFields = {
      gafas: ["marca", "modeloNombreComercial", "color"],
      LC: ["marca", "modeloNombreComercial", "color"],
      audifonos: ["marca", "modeloNombreComercial"],
    };

    const fields = categoryFields[e.categoria] || [];
    const product = e.productos?.[`prod${pos + 1}`];

    return product
      ? fields
          .map((field) => product[field])
          .filter(Boolean)
          .join(" ")
      : "";
  }

  async function handleDeleteProduct(id, idFicha, pos) {
    await post("/support-extra/cesta/EliminarProductoCesta.php", {
      token: userData.token,
      idCestaProducto: id,
    });
    setData((prevData) =>
      prevData.map((ficha) => {
        if (ficha.idFicha !== idFicha) return ficha;

        let newProductos = { ...ficha.productos };
        let newExtras = [...ficha.extras];

        if (pos === "extras") {
          newExtras = newExtras.filter((extra) => extra.idCestaProducto !== id);
        } else {
          newProductos = {
            ...newProductos,
            [`prod${pos}`]: {},
          };
        }

        const newTotal =
          (newProductos.prod1?.totalPrecio || 0) +
          (newProductos.prod2?.totalPrecio || 0) +
          (newProductos.prod3?.totalPrecio || 0) +
          (newProductos.extras?.reduce(
            (acc, extra) => acc + (extra.total || 0),
            0,
          ) || 0);

        return {
          ...ficha,
          productos: newProductos,
          extras: newExtras,
          total: newTotal.toFixed(2),
        };
      }),
    );
  }

  async function handleDeleteRecord(idFicha) {
    setData((prevData) =>
      prevData.filter((ficha) => ficha.idFicha !== idFicha),
    );
    await post("/support-extra/cesta/EliminarFichaCesta.php", {
      token: userData.token,
      idFicha: idFicha,
    });
  }

  function getRecordName(e) {
    let name = "";
    switch (e.categoria) {
      case "gafas":
        name = `Ficha de gafas de ${e.sol ? "Sol" : "Vista"}`;
        break;
      case "LC":
        name = "Ficha de lentes de contacto";
        break;
      case "audifonos":
        name = "Ficha de audífonos";
        break;
      default:
        break;
    }
    return name;
  }

  function getIcon(category, pos) {
    const labels = {
      gafas: ["menu-gafas-blue.svg", "lente-blue.svg", "lente-blue.svg"],
      LC: [
        "menu-lentillas-blue.svg",
        "menu-lentillas-blue.svg",
        "liquido-blue.svg",
      ],
      audifonos: ["audifono-blue.svg", "audifono-blue.svg", "bateria-blue.svg"],
    };

    return labels[category]?.[pos] || "";
  }

  function calculateTotal() {
    const newTotal = data.reduce((acc, e) => acc + parseFloat(e.total || 0), 0);
    setTotal(newTotal.toFixed(2));
  }

  const onClickVenta = () => {
    const orderCards = [];
    let counter = 1;
    data.forEach((d) => {
      let order = prepareOrder(
        {
          prod1: d.productos.prod1,
          prod2: d.productos.prod2,
          prod3: d.productos.prod3,
          extras: d.extras,
        },
        d.idFicha,
        patientId,
        d.categoria,
        counter,
      );
      if (d.sol) {
        order.category = "SOL";
      }
      counter = counter + 3 + d.extras.length;
      orderCards.push(order);
    });

    onClickMenuOption("venta", {
      saleId: -1,
      orderCards,
      orderPatientId: patientId,
    });
    onClose();
  };

  const onClickEncargo = () => {
    const orderCards = [];
    let counter = 1;
    data.forEach((d) => {
      let order = prepareOrder(
        {
          prod1: d.productos.prod1,
          prod2: d.productos.prod2,
          prod3: d.productos.prod3,
          extras: d.extras,
        },
        d.idFicha,
        patientId,
        d.categoria,
        counter,
      );
      if (d.sol) {
        order.category = "SOL";
      }
      counter = counter + 3 + d.extras.length;
      orderCards.push(order);
    });

    onClickMenuOption("encargo", {
      saleId: -1,
      orderCards,
      orderPatientId: patientId,
    });
    onClose();
  };

  const onClickPresupuesto = () => {
    const orderCards = [];
    let counter = 1;
    data.forEach((d) => {
      let order = prepareOrder(
        {
          prod1: d.productos.prod1,
          prod2: d.productos.prod2,
          prod3: d.productos.prod3,
          extras: d.extras,
        },
        d.idFicha,
        patientId,
        d.categoria,
        counter,
      );
      if (d.sol) {
        order.category = "SOL";
      }
      counter = counter + 3 + d.extras.length;
      orderCards.push(order);
    });

    onClickMenuOption("presupuesto", {
      saleId: -1,
      orderCards,
      orderPatientId: patientId,
    });
    onClose();
  };

  const onClickProforma = () => {
    const orderCards = [];
    let counter = 1;
    data.forEach((d) => {
      let order = prepareOrder(
        {
          prod1: d.productos.prod1,
          prod2: d.productos.prod2,
          prod3: d.productos.prod3,
          extras: d.extras,
        },
        d.idFicha,
        patientId,
        d.categoria,
        counter,
      );
      if (d.sol) {
        order.category = "SOL";
      }
      counter = counter + 3 + d.extras.length;
      orderCards.push(order);
    });

    onClickMenuOption("proforma", {
      saleId: -1,
      orderCards,
      orderPatientId: patientId,
    });
    onClose();
  };

  useEffect(() => {
    getShoppingCart();
  }, []);

  useEffect(() => {
    calculateTotal();
  }, [data]);

  return (
    <div className="popup-container">
      <div className="popup-screen popup-screen-sc">
        <div className="popup-screen-header">
          <button className="popup-action-icon close-icon" onClick={onClose}>
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
          <span className="popup-screen-header-title">Cesta</span>
        </div>
        <div className="tab-content tab-content-sc background-gray">
          {loadingData && (
            <LoadingScreen message="Cargando cesta..."></LoadingScreen>
          )}
          {!loadingData && (
            <div className="sm-container container-panel">
              <span className="sm-container-info">
                Actualmente tiene {data.length} fichas para procesar.
              </span>
              <div className="sc-total-info">
                <span className="cell-label">TOTAL</span>
                <span className="opt-table-subtitle">
                  {formatValueUnit(total, "€")}
                </span>
              </div>
              {data.length > 0 && (
                <div className="sc-product-list">
                  {data.map((e) => {
                    return (
                      <div className="sc-product-data" key={e.idFicha}>
                        <div className="opt-table-content grid-3" id="sc-grid">
                          <div className="cell combined-cells-3 cell-start-content cell-label">
                            {e.nombreCliente}
                          </div>
                          <div className="cell combined-cells-2 cell-start-content opt-table-title">
                            {`${getRecordName(e)} (id: ${e.idFicha})`}
                          </div>
                          <div className="cell">
                            <img
                              src={`/images/remove-blue.svg`}
                              className="icon-pref"
                              alt="Eliminar producto"
                              onClick={() => {
                                createPopupQuestion(
                                  `¿Desea eliminar la ficha y todos sus productos de la cesta?`,
                                  async () => {
                                    await handleDeleteRecord(e.idFicha);
                                    removePopupQuestion();
                                  },
                                  removePopupQuestion,
                                  "Sí",
                                  "No",
                                );
                              }}
                            ></img>
                          </div>
                          {Object.keys(e.productos.prod1).length > 0 && (
                            <>
                              <div className="cell opt-table-subtitle cell-start-content">
                                <img
                                  src={`/images/${getIcon(e.categoria, 0)}`}
                                  className="icon-pref"
                                  alt="Icono"
                                ></img>
                                <span className="cell-label">
                                  {getLabel(e.categoria, 0)}:
                                </span>
                                {showData(e, 0)}
                              </div>
                              <div className="cell cell-end-content opt-table-subtitle">
                                {formatValueUnit(
                                  Number(e.productos.prod1?.totalPrecio) || 0,
                                  "€",
                                )}
                              </div>
                              <div className="cell">
                                <img
                                  src={`/images/remove-blue.svg`}
                                  className="icon-pref"
                                  alt="Eliminar producto"
                                  onClick={() => {
                                    createPopupQuestion(
                                      `¿Desea eliminar el producto de la cesta?`,
                                      async () => {
                                        await handleDeleteProduct(
                                          e.productos.prod1?.idCestaProducto,
                                          e.idFicha,
                                          1,
                                        );
                                        removePopupQuestion();
                                      },
                                      removePopupQuestion,
                                      "Sí",
                                      "No",
                                    );
                                  }}
                                ></img>
                              </div>
                            </>
                          )}
                          {Object.keys(e.productos.prod2).length > 0 && (
                            <>
                              <div className="cell opt-table-subtitle cell-start-content">
                                <img
                                  src={`/images/${getIcon(e.categoria, 1)}`}
                                  className="icon-pref"
                                  alt="Icono"
                                ></img>
                                <span className="cell-label">
                                  {getLabel(e.categoria, 1)}:
                                </span>
                                {Object.keys(e.productos.prod2).length > 0
                                  ? showData(e, 1)
                                  : "Eliminada"}
                              </div>
                              <div className="cell cell-end-content opt-table-subtitle">
                                {formatValueUnit(
                                  Number(e.productos.prod2?.totalPrecio) || 0,
                                  "€",
                                )}
                              </div>
                              <div className="cell">
                                <img
                                  src={`/images/remove-blue.svg`}
                                  className="icon-pref"
                                  alt="Eliminar producto"
                                  onClick={() => {
                                    createPopupQuestion(
                                      `¿Desea eliminar el producto de la cesta?`,
                                      async () => {
                                        await handleDeleteProduct(
                                          e.productos.prod2?.idCestaProducto,
                                          e.idFicha,
                                          2,
                                        );
                                        removePopupQuestion();
                                      },
                                      removePopupQuestion,
                                      "Sí",
                                      "No",
                                    );
                                  }}
                                ></img>
                              </div>
                            </>
                          )}
                          {Object.keys(e.productos.prod3).length > 0 && (
                            <>
                              <div className="cell opt-table-subtitle cell-start-content">
                                <img
                                  src={`/images/${getIcon(e.categoria, 2)}`}
                                  className="icon-pref"
                                  alt="Icono"
                                ></img>
                                <span className="cell-label">
                                  {getLabel(e.categoria, 2)}:
                                </span>
                                {Object.keys(e.productos.prod3).length > 0
                                  ? showData(e, 2)
                                  : "Eliminada"}
                              </div>
                              <div className="cell cell-end-content opt-table-subtitle">
                                {formatValueUnit(
                                  Number(e.productos.prod3?.totalPrecio) || 0,
                                  "€",
                                )}
                              </div>
                              <div className="cell">
                                <img
                                  src={`/images/remove-blue.svg`}
                                  className="icon-pref"
                                  alt="Eliminar producto"
                                  onClick={() => {
                                    createPopupQuestion(
                                      `¿Desea eliminar el producto de la cesta?`,
                                      async () => {
                                        await handleDeleteProduct(
                                          e.productos.prod3?.idCestaProducto,
                                          e.idFicha,
                                          3,
                                        );
                                        removePopupQuestion();
                                      },
                                      removePopupQuestion,
                                      "Sí",
                                      "No",
                                    );
                                  }}
                                ></img>
                              </div>
                            </>
                          )}
                          {e.extras?.map((extra) => {
                            return (
                              <React.Fragment key={extra.idCestaProducto}>
                                <div className="cell opt-table-subtitle cell-start-content">
                                  <img
                                    src={`/images/extra-blue.svg`}
                                    className="icon-pref"
                                    alt="Icono"
                                  ></img>
                                  <span className="cell-label">Extra</span>
                                  {`${extra.descripcion}`}
                                </div>
                                <div className="cell cell-end-content opt-table-subtitle">
                                  {formatValueUnit(extra.total, "€")}
                                </div>
                                <div className="cell">
                                  <img
                                    src={`/images/remove-blue.svg`}
                                    className="icon-pref"
                                    alt="Eliminar producto"
                                    onClick={() => {
                                      createPopupQuestion(
                                        `¿Desea eliminar el producto de la cesta?`,
                                        async () => {
                                          await handleDeleteProduct(
                                            extra.idCestaProducto,
                                            e.idFicha,
                                            "extras",
                                          );
                                          removePopupQuestion();
                                        },
                                        removePopupQuestion,
                                        "Sí",
                                        "No",
                                      );
                                    }}
                                  ></img>
                                </div>
                              </React.Fragment>
                            );
                          })}
                          <div className="cell cell-label cell-end-content">
                            TOTAL:
                          </div>
                          <div className="cell opt-table-subtitle cell-end-content">
                            {formatValueUnit(e.total, "€")}
                          </div>
                          <div className="cell"></div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              {data.length > 0 && (
                <div className="popup-buttons">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 10,
                    }}
                  >
                    <ButtonIconH
                      text="Venta"
                      onClick={onClickVenta}
                    ></ButtonIconH>
                    <ButtonIconH
                      text="Encargo"
                      onClick={onClickEncargo}
                    ></ButtonIconH>
                    <ButtonIconH
                      text="Presupuesto"
                      onClick={onClickPresupuesto}
                    ></ButtonIconH>
                    <ButtonIconH
                      text="Proforma"
                      onClick={onClickProforma}
                    ></ButtonIconH>
                  </div>
                  <ButtonIconH text="Volver" onClick={onClose}></ButtonIconH>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
